// Models
import { AuditTrailActionTypes } from 'app/shared/auditTrail/models';

export const selectAuditTrail = (state: RootState) => {
  return state.auditTrail.auditTrailDetails;
};

// Loading
export const selectAuditTrailLoading = (state: RootState) => {
  return Boolean(state.loading[AuditTrailActionTypes.RETRIEVE_AUDIT_TRAIL]);
};
